/**
 * OUTFIT — Configuration AWS
 */

// CJ Affiliate API
// Token à générer sur developers.cj.com → Personal Access Token
export const CJ_CONFIG = {
  token:     '1LZH7LlDz6I6eISKA9rXMxxr7g',
  companyId: '7931766',
  publisherId: '101729219',
};

export const AWS_CONFIG = {
  region:           'eu-west-3',
  userPoolId:       'eu-west-3_Mk4tmYSEM',
  userPoolClientId: 'j28a3vdnl0fb5gkc8lg7hkbsf',
  apiUrl:           'https://on0ym6si4l.execute-api.eu-west-3.amazonaws.com/prod',
  // v1.12.388 — Nouveau backend AWS Looks (CDK : mytenue-aws-cdk)
  // Cache pré-calculé des Looks AI (per-user) + Sélection styliste (partagé).
  // Voir docs/MIGRATION.md du repo mytenue-aws-cdk pour le contrat API.
  looksApiUrl:      'https://1lii8ay0pl.execute-api.eu-west-3.amazonaws.com',
  wardrobeBucket:   'outfit-photos-201064226116',
  cjToken:          CJ_CONFIG.token,
  cjCompanyId:      CJ_CONFIG.companyId,
  cjPublisherId:    CJ_CONFIG.publisherId,
  oauth: {
    // v1.12.268 — custom domain Cognito : auth.mytenue.com au lieu de outfit-app.auth.eu-west-3.amazoncognito.com
    // Google Sign-In affiche "to continue to auth.mytenue.com" au lieu de l'URL AWS générique.
    domain:          'auth.mytenue.com',
    scope:           ['email', 'openid', 'profile'],
    redirectSignIn:  'outfit://callback',
    redirectSignOut: 'outfit://logout',
    responseType:    'code',
  },
};

export const IS_AWS_CONFIGURED = true;
